export const SHARE_LIMITS = {
    /** A share's name, as a picture's. */
    name: 120,
    /** Pictures and sounds in one share. */
    items: 200,
    /** People named on one share. */
    members: 50,
    /** Shares one person keeps. */
    shares: 50,
    /** A handle as the site bounds one. */
    handle: 64,
};
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** The share's name: one line, 1–120 characters after trimming; null otherwise. */
export function parseShareName(raw) {
    if (typeof raw !== 'string')
        return null;
    const name = raw.trim();
    return name.length >= 1 && name.length <= SHARE_LIMITS.name && !/[\r\n\0]/.test(name) ? name : null;
}
/** The items a share holds: distinct `{ kind, id }`, at most 200; null for anything else. */
export function parseShareItems(raw) {
    if (!Array.isArray(raw) || raw.length > SHARE_LIMITS.items)
        return null;
    const seen = new Set();
    const out = [];
    for (const x of raw) {
        if (!x || typeof x !== 'object')
            return null;
        const { kind, id } = x;
        if ((kind !== 'picture' && kind !== 'audio') || typeof id !== 'string' || !UUID.test(id))
            return null;
        const key = `${kind}:${id.toLowerCase()}`;
        if (seen.has(key))
            continue;
        seen.add(key);
        out.push({ kind, id: id.toLowerCase() });
    }
    return out;
}
/** The handles the owner typed: strings of 1–64 characters, at most 50, a leading @ dropped; null for anything else. */
export function parseShareHandles(raw) {
    if (!Array.isArray(raw) || raw.length > SHARE_LIMITS.members)
        return null;
    const out = [];
    for (const x of raw) {
        if (typeof x !== 'string')
            return null;
        const h = x.normalize('NFC').trim().replace(/^@/, '');
        if (!h || h.length > SHARE_LIMITS.handle)
            return null;
        if (!out.includes(h))
            out.push(h);
    }
    return out;
}
//# sourceMappingURL=shares.js.map